import $ from "jquery";
import "./../styles/main.scss";
import "leaflet-providers";
import Plyr from "plyr";
import { siblings } from '@glidejs/glide/src/utils/dom';
import AOS from "aos";
import Cookies from "js-cookie";
require("./helpers/sticky");
// const InstagramFeed = require("instafeed");
var CustomActiveClass = function (Glide, Components, Events) {
    var Component = {
        mount: function () {
            this.changeActiveSlide();
        },
        changeActiveSlide: function () {
            var slide = Components.Html.slides[Glide.index];
            slide.classList.remove('is-next', 'is-prev');
            slide.classList.add('is-active');
            siblings(slide).forEach(function (sibling) {
                sibling.classList.remove('is-active', 'is-next', 'is-prev');
            });
            if (slide.nextElementSibling) {
                slide.nextElementSibling.classList.add('is-next');
            }
            if (slide.previousElementSibling) {
                slide.previousElementSibling.classList.add('is-prev');
            }
        }
    };
    Events.on('run', function () {
        Component.changeActiveSlide();
    });
    return Component;
};
require("./ui/Cursor");
require("./ui/Menu");
require("./ui/Input");
require("./ui/Form");
import vidbg from "./ui/VidBg";
import Glide from "@glidejs/glide";
import "animate.css";
import Rellax from "rellax";
require("jquery.scrollto");
require("./helpers/ihavecookies");
$(document).ready(function () {
    AOS.init();
    $('.article-wrapper a').each(function (i, e) {
        $(e).attr("target", "_blank");
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 20) {
            $('#logo').addClass('hide');
        }
        if ($(window).scrollTop() < 20) {
            $('#logo').removeClass('hide');
        }
    });
    if ($('.page-template-tpl-landingpage').length) {
        $(".sticky-button-wrapper").sticky({ topSpacing: 0 });
    }
    // $('.caldera_forms_form .first_row').on("change blur", "input", (e) => {
    //     $(e.currentTarget).parents(".caldera_forms_form").find(".row").fadeIn(400);
    //     $(e.currentTarget).parents(".pointer.input").children("p").html($(e.currentTarget).val() + ' <span aria-hidden="true" role="presentation" class="field_required" style="color:#ee0000;">*</span>');
    //     $(e.currentTarget).parents(".pointer.input").trigger("click");
    // }); 
    if ($('.rellax').length) {
        var rellax = new Rellax('.rellax', {
            // speed: -2,
            center: true
            // center: false
        });
    }
    // const jsplayer = new Plyr(document.querySelector('.js-player'), {
    //     iconUrl: "/app/themes/lumber/static/gfx/plyr.svg"
    // });
    var players = Array.from(document.querySelectorAll('.js-player')).map(function (p) { return new Plyr(p, {
        iconUrl: "/app/themes/lumber/static/gfx/plyr.svg"
    }); });
    if ($('.page-template-tpl-team').length) {
        // new InstagramFeed({
        //     'username': 'alpaga_agency',
        //     'container': document.getElementById("instagram-feed"),
        //     'display_profile': false,
        //     'display_biography': false,
        //     'display_gallery': true,
        //     'callback': null,
        //     'styling': true,
        //     'items': 8,
        //     'items_per_row': 4,
        //     'margin': 1,
        //     'lazy_load': true,
        //     'on_error': console.error
        // });
    }
    $("body").on("click", "a[data-ajax-news]", function (e) {
        e.preventDefault();
        $.get($(e.currentTarget).attr("href"), function (data) {
            $('.action.desktop.active').addClass("remove");
            var html = $(data);
            $('.filters a.current').removeClass("current");
            $('.filter-mobile li.current').removeClass('current');
            $('.filter-mobile ul').children("li:eq(" + $(e.currentTarget).parent().index() + ")").addClass("current");
            $(e.currentTarget).addClass("current");
            var news = $(html).find(".news").html();
            history.pushState({}, "Ajax", $(e.currentTarget).attr("href"));
            $.scrollTo(0, 500);
            $("body").find(".news").animate({ opacity: 0 }, 250, function () {
                $("body").find(".news").html(news);
                $("body").find(".news").animate({ opacity: 1 }, 250);
                setTimeout(function () {
                    $('.action.desktop.active.remove').removeClass("active remove");
                }, 500);
            });
        });
    });
    $("body").on("click", "a.ajax", function (e) {
        e.preventDefault();
        $.get($(e.currentTarget).attr("href"), function (data) {
            $('.action.desktop.active').addClass("remove");
            var html = $(data);
            $('.filters a.current').removeClass("current");
            $(e.currentTarget).addClass("current");
            var sliderWrapper = $(html).find(".slider-wrapper").removeClass("animated fadeIn");
            var sliders = $("body").find(".slider-wrapper");
            sliders.css({ opacity: 1 }).removeClass("fadeIn");
            $('.filter-mobile li.current').removeClass('current');
            $('.filter-mobile ul').children("li:eq(" + $(e.currentTarget).parent().index() + ")").addClass("current");
            sliders.animate({ opacity: 0 }, 250, function () {
                setTimeout(function () {
                    $('.action.desktop.active.remove').removeClass("active remove");
                }, 500);
                sliders.html(sliderWrapper.html());
                sliders.animate({ opacity: 1 }, 250);
                $('.glide').each(function (i, e) {
                    var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
                    var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
                    var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
                    var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
                    var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
                    var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
                    var glide = new Glide(e, {
                        type: type,
                        focusAt: focus,
                        perView: view,
                        gap: gap,
                        startAt: 0,
                        breakpoints: {
                            680: {
                                focusAt: "center",
                                gap: mobileGap,
                                perView: mobileView
                            }
                        }
                    });
                    glide.mount({
                        'CustomActiveClass': CustomActiveClass
                    });
                });
            });
        });
        // $.get($(e.currentTarget).attr("href"), (data) => {
        //     let html = $(data);
        //     $('.filters a.current').removeClass("current");
        //     $(e.currentTarget).addClass("current");
        //     let sliderWrapper = $(html)
        //         .find(".slider-wrapper");
        //     // sliderWrapper.find(".glide__slide").addClass("animated fadeOut");
        //     $("body").find(".slider-wrapper").find(".glide__slide").addClass("animated fadeOutUp");
        //     $("body").find(".slider-wrapper").addClass("fadeOut");
        //     setTimeout(() => {
        //         $("body").find(".slider-wrapper").html(sliderWrapper.html());
        //         $("body").find(".slider-wrapper").removeClass("fadeOut fadeIn").addClass("fadeIn");
        //         $('.glide').each((i,e) => {
        //             let gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
        //             let mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
        //             let view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
        //             let mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
        //             let type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
        //             let focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
        //             let glide = new Glide(e, {
        //                 type: type,
        //                 focusAt: focus,
        //                 perView: view,
        //                 gap: gap,
        //                 startAt: 0,
        //                 breakpoints: {
        //                     680 : {
        //                         focusAt: "center",
        //                         gap: mobileGap,
        //                         perView: mobileView
        //                     }
        //                 }
        //             });
        //             glide.mount({
        //                 'CustomActiveClass': CustomActiveClass,
        //             });
        //         });
        //     }, 2000);
        // });
    });
    // $('*[data-appear]').css({ opacity: 0 });
    if ($('.video-bg').length) {
        if ($('.video-bg').length) {
            var link = $('.video-bg').data("video");
            var instance = new vidbg('.video-bg', {
                mp4: link,
                // poster: 'path/to/fallback.jpg', // URL or relative path to fallback image
                overlay: false,
                overlayColor: '#000',
                overlayAlpha: 0.3 // The overlay alpha. Think of this as the last integer in RGBA()
            }, {
                autoplay: true
            });
            instance.videoEl.play();
        }
        var player_1 = new Plyr("#player");
        player_1.on("playing", function (event) {
            if (!$("#main-header").hasClass("back")) {
                player_1.pause();
            }
        });
        $("a[href='#showreel']").on("click", function (e) {
            e.preventDefault();
            $('#main-header').addClass("back");
            $("#showreel").fadeIn(500, function () {
                player_1.play();
            });
        });
        $("a[href='#close-showreel']").on("click", function (e) {
            e.preventDefault();
            $("#showreel").fadeOut(500);
            $('#main-header').removeClass("back");
            player_1.pause();
        });
    }
    $('body').on("click", ".filter-mobile", function (e) {
        e.preventDefault();
        $('.action.desktop').addClass("active");
        $('#main-header').addClass("back");
    });
    $('body').on("click", ".action.desktop .close-action", function (e) {
        e.preventDefault();
        $('.action.desktop').addClass("remove");
        setTimeout(function () {
            $('.action.desktop').removeClass("active");
            $('.action.desktop').removeClass("remove");
        }, 850);
        $('#main-header').removeClass("back");
    });
    // inView.offset(100);
    // inView('*[data-appear]')
    // .on('enter', el => {
    //     let $this = $(el);
    //     if ($this.attr('data-appearlater') === void 0) {
    //         // $this.addClass('fast animated '+$this.attr('data-appear'));
    //         setTimeout(function(){
    //             $this.addClass('faster animated '+$this.attr('data-appear'));
    //         }, $this.attr('data-appeartiming') !== void 0 ? parseInt($this.attr('data-appeartiming')) : 0 );
    //     }
    // });
    // $('*[data-appearlater]').each(function(i, e){
    //     var $this = $(e);
    //     setTimeout(function(){
    //         $this.addClass('faster animated '+$this.attr('data-appear'));
    //     },200*i);
    // });
    if ($('.glide').length) {
        $('.glide').each(function (i, e) {
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                bound: true,
                breakpoints: {
                    680: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            glide.on("run.before", function (move) {
                console.log(move);
            });
            glide.mount({
                'CustomActiveClass': CustomActiveClass
            });
        });
    }
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    if ($("#pop-up-system").length) {
        var parent_1 = $("#pop-up-system");
        var frequency_1 = parent_1.attr("data-frequency");
        var timing = parent_1.attr("data-timing");
        var popUpId_1 = parent_1.attr("data-popup-id");
        var overlay = parent_1.children('.overlay');
        var popupContent = parent_1.children(".window");
        if (Cookies.get('popup-' + popUpId_1) === void 0) {
            setTimeout(function () {
                parent_1.show();
                parent_1.addClass("active");
            }, parseInt(timing));
        }
        else {
            if ((Cookies.get('popup-' + popUpId_1) == "always" || frequency_1 == "always") && Cookies.get('popup-' + popUpId_1) != "hide") {
                setTimeout(function () {
                    parent_1.show();
                    parent_1.addClass("active");
                }, parseInt(timing));
            }
        }
        function removePopUp() {
            parent_1.removeClass("active");
            setTimeout(function () {
                if (Cookies.get('popup-' + popUpId_1) != "hide") {
                    if (frequency_1 == "once") {
                        Cookies.set('popup-' + popUpId_1, frequency_1);
                    }
                }
                parent_1.remove();
            }, 1500);
        }
        overlay.on("click", function (e) {
            removePopUp();
        });
        parent_1.on("click", ".close a", function (e) {
            e.preventDefault();
            removePopUp();
        });
        $(document).on('keydown', function (e) {
            if (e.key == "Escape")
                removePopUp();
        });
    }
});
